import React from "react";
import { wrapCollectionLayout } from "@quintype/components";
import { StoryCard, StoryCardSimple } from "../basic/story-card.js";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { SectionName } from "../basic/section-name.js";
import "./two-col-highlight.module.css";

function TwoColHighlightBase({stories = [], metadata = {}, collection, associatedMetadata }) {
  const length = stories ? stories.length : 0;
  const config = {
    image: true,
    imageAspectRatio: [4, 3],
  };
  const story = get(stories, [0], {});
  if(length < 4) {
    return <div data-comment="At least four stories required for a TwoColHighlight"></div>
  }
  const {'show_collection_title' : collectionName = true} = associatedMetadata;
  return (
    <div styleName="component-wrapper">
     { collectionName ? <SectionName  name={collection.name} type="large"/> : null}
    <div  styleName="container">
      <div styleName="story-with-highlighted-card fix-height">
        <Link href={`/${story.slug}`} className="story-card-link">
          <StoryCardSimple
            config={config}
            pickOfTheDay={true}
            story={story}
            hideSectionName={true}
            titleofTheHighlightedStory={metadata.titleofTheHighlightedStory}
            aspectRatio={[4, 3]}
            />
          </Link>
        </div>
      <div styleName="story-with-card fix-height">
      {
        stories.slice(1, 4).map((story) => {
           return <Link href={`/${story.slug}`} className="story-card-link">
               <StoryCardSimple key={story.id} story={story} hideSectionName={true} config={config} />
             </Link>
        })
      }
    </div>
  </div>
  </div>
  )

}

export const TwoColHighlight = wrapCollectionLayout(TwoColHighlightBase);
